/** Ліміти полів контактної особи постачальника (ПІБ + посада + короткий опис) */
export const VENDOR_PERSON_LIMITS = {
    fullName: 100,
    position: 80,
    description: 250,
};
